import { MyClients } from "@/components/pages/Client/MyClients";
import { ClientScopeProvider } from "@/components/pages/Client/settings/ClientScopeContext";
import { useManageClient } from "../context";

/**
 * Operator "EA's Clients" tab. Only reachable when the managed client is an Executive
 * Assistant or Travel Manager (see the conditional TABS in ManageClient). Reuses the EA's own
 * `MyClients` two-panel view, scoped to the managed EA via the route `:clientId`:
 *  - `accountId={clientId}` threads the EA's uuid into the access queries, so the list shows the
 *    clients that EA manages (their `type=YOU_MANAGE` access) rather than the logged-in account's.
 *  - `readOnly` makes the tab view-only — an operator may view the EA's clients but not act on them:
 *    Request Client Access, Remove My Access, and pending Cancel/Resend are all hidden. Removing an
 *    EA from a client is done from that client's own Settings → Assistants, not here.
 *  - `title="EA's Clients"` matches the Figma section heading (the EA portal keeps "My Clients").
 *
 * Wrapped in `ClientScopeProvider` for parity with the sibling Manage-Client tabs (Favourites,
 * Settings): it scopes any reused client descendant to the managed account.
 */
export const ManageClientEaClients = () => {
  const { clientId } = useManageClient();

  return (
    <ClientScopeProvider accountId={clientId}>
      <MyClients accountId={clientId} readOnly title="EA's Clients" />
    </ClientScopeProvider>
  );
};
